/**
 * Assigns identifying properties to the users cookie, used before any tracking can be done
 * @param {{email: String, firstName: String, lastName: String, zip: String, birthdate: String, phone: String, gender: String}} body An object containing all of the required tracking properties
 */
export const identify = ({ email, firstName, lastName, zip, birthdate, phone, gender }) => {
  if (global.window && window._learnq) {
    window._learnq.push([
      'identify',
      {
        $email: email,
        $first_name: firstName,
        $last_name: lastName,
        $zip: zip,
        $birthdate: birthdate,
        $phone_number: phone,
        $gender: gender,
        $user_zip: zip
      }
    ]);
  }
};

/**
 * Submits tracking event for "Viewed Product"
 * @param {String} packageName - The name of the package viewed by user
 */
export const productViewed = packageName => {
  if (global.window && window._learnq) {
    window._learnq.push([
      'track',
      'Viewed Product',
      {
        Package_name: packageName
      }
    ]);
  }
};

/**
 * Submits tracking event for "Got a Quote"
 * @param {String} packageName - The name of the package viewed by user
 */
export const quoteIssued = packageName => {
  if (global.window && window._learnq) {
    window._learnq.push([
      'track',
      'Got a Quote',
      {
        Package_name: packageName
      }
    ]);
  }
};

/**
 * Submits tracking event for "Started Checkout"
 * @param {{packageName: String, term: String, priceMonthly: String, priceTotal: String, providerName: String, providerAddress: {street: String, street2: String, city: String, state: String, zip: String}}} body An object containing all of the required tracking properties
 */
export const checkoutStarted = ({
  packageName,
  term,
  priceMonthly,
  priceTotal,
  providerName,
  providerAddress
}) => {
  if (global.window && window._learnq) {
    window._learnq.push([
      'track',
      'Started Checkout',
      {
        package_name: packageName,
        payment_term_months: term,
        payment_cost_monthly: priceMonthly,
        payment_cost_total: priceTotal,
        provider_name: providerName,
        provider_address_street: providerAddress?.street,
        provider_address_street2: providerAddress?.street2,
        provider_address_city: providerAddress?.city,
        provider_address_state: providerAddress?.state,
        provider_address_zip: providerAddress?.zip
      }
    ]);
  }
};

/**
 * Submits tracking event for "Completed Checkout Step"
 * @param {{packageName: String, term: String, priceMonthly: String, priceTotal: String, providerName: String, providerAddress: {street: String, street2: String, city: String, state: String, zip: String}}} body An object containing all of the required tracking properties
 */
export const checkoutCompleted = ({
  packageName,
  term,
  priceMonthly,
  priceTotal,
  providerName,
  providerAddress
}) => {
  if (global.window && window._learnq) {
    window._learnq.push([
      'track',
      'Completed Checkout Step',
      {
        package_name: packageName,
        payment_term_months: term,
        payment_cost_monthly: priceMonthly,
        payment_cost_total: priceTotal,
        provider_name: providerName,
        provider_address_street: providerAddress?.street,
        provider_address_street2: providerAddress?.street2,
        provider_address_city: providerAddress?.city,
        provider_address_state: providerAddress?.state,
        provider_address_zip: providerAddress?.zip
      }
    ]);
  }
};
